import {
  Switch as MantineSwitch,
  type SwitchProps as MantineSwitchProps,
} from "@mantine/core";
import type { CoreComponentProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type SwitchProps = CoreComponentProps<MantineSwitchProps, 'button'>;

export function Switch({ testId, view = "all", ...rest }: SwitchProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineSwitch data-testid={testId} {...rest} />;
}
